import { render, staticRenderFns } from "./GraphSimulation.vue?vue&type=template&id=6b860063&scoped=true"
import script from "./GraphSimulation.vue?vue&type=script&lang=js"
export * from "./GraphSimulation.vue?vue&type=script&lang=js"
import style0 from "./GraphSimulation.vue?vue&type=style&index=0&id=6b860063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b860063",
  null
  
)

export default component.exports